import React from 'react';
import { motion } from 'framer-motion';
import {
  BanknotesIcon,
  WalletIcon,
  CheckCircleIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import PageHeader from '../ui/PageHeader';
import { useLanguage } from '../../contexts/LanguageContext';

const MOVEMENTS = [
  { t: 'Bono programa socios', a: '+$40.00', kind: 'money' },
  { t: 'Canje puntos → cupón', a: '-500 pts', kind: 'pts' },
  { t: 'Recompensa referido', a: '+120 pts', kind: 'pts' },
];

function ClientWalletView() {
  const { t } = useLanguage();
  const e = t.enrola;
  const w = e.walletView;

  return (
    <div className="space-y-6 xl:space-y-7">
      <PageHeader
        eyebrow="Enrola"
        icon={WalletIcon}
        title={e.wallet}
        subtitle={w.subtitle}
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          className="card-premium interactive-lift p-4 sm:p-6 bg-gradient-to-br from-orange-50 to-amber-50   "
        >
          <div className="flex items-center justify-between mb-4">
            <p className="stat-label text-secondary-700 ">{w.points}</p>
            <div className="icon-tile h-10 w-10 from-orange-500 to-amber-500">
              <WalletIcon className="w-5 h-5 text-white" />
            </div>
          </div>
          <p className="text-4xl font-bold tracking-tight text-orange-600 ">3.240</p>
          <p className="text-sm text-secondary-600 mt-2">{w.pointsAccumulated}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          className="card-premium interactive-lift p-4 sm:p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <p className="stat-label text-secondary-700 ">{w.moneyEnabled}</p>
            <div className="icon-tile h-10 w-10 from-emerald-500 to-teal-500">
              <BanknotesIcon className="w-5 h-5 text-white" />
            </div>
          </div>
          <p className="text-4xl font-bold tracking-tight text-success-600 ">$180.00</p>
          <p className="text-sm text-secondary-600 mt-2">
            {w.moneyRules}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="card-premium interactive-lift p-4 sm:p-6 bg-gradient-to-br from-emerald-50 to-white border border-emerald-100   "
        >
          <div className="flex items-center justify-between mb-4">
            <p className="stat-label text-secondary-700 ">{w.readyToCollect}</p>
            <div className="icon-tile h-10 w-10 from-green-500 to-emerald-500">
              <CheckCircleIcon className="w-5 h-5 text-white" />
            </div>
          </div>
          <p className="text-4xl font-bold tracking-tight text-emerald-700 ">$95.00</p>
          <p className="text-sm text-secondary-600 mt-2">
            {w.withdrawRequestHint}
          </p>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="card-premium p-4 sm:p-6"
      >
        <div className="flex items-center gap-2 mb-4">
          <ClockIcon className="w-5 h-5 text-secondary-500" />
          <h3 className="text-lg font-semibold text-secondary-900 ">
            {w.recentMovements}
          </h3>
        </div>
        <ul className="divide-y divide-secondary-100 ">
          {MOVEMENTS.map((row) => (
            <li
              key={row.t}
              className="py-3 flex justify-between gap-3 text-sm text-secondary-800 "
            >
              <span className="min-w-0 truncate">{row.t}</span>
              <span
                className={
                  row.kind === 'money' ? 'text-success-700 font-semibold' : ''
                }
              >
                {row.a}
              </span>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  );
}

export default ClientWalletView;
